export default "__VITE_ASSET__CbmW3dPG__"